const Login = () => import('@/views/Login');
const LoginForm = () => import('@/views/Login/LoginForm');
const ForgetPassword = () => import('@/views/Login/ForgetPassword');
const ChangeToNewPassword = () => import('@/views/Login/ChangeToNewPassword');
const ForceChangePassword = () => import('@/views/Login/ForceChangePassword');
const Logout = () => import('@/views/Login/Logout');
const AccountLink = () => import('@/views/Login/AccountLink');

export default {
  path: '/login',
  component: Login,
  children: [
    {
      path: '/',
      name: 'login-form',
      component: LoginForm,
      meta: { loginRoute: true },
    },
    {
      path: '/login/forget-password',
      name: 'forget-password',
      component: ForgetPassword,
      meta: { loginRoute: true },
    },
    {
      path: '/login/change-to-new-password',
      name: 'change-to-new-password',
      component: ChangeToNewPassword,
      meta: { loginRoute: true },
    },
    {
      path: '/login/force-change-password',
      name: 'force-change-password',
      component: ForceChangePassword,
      meta: { loginRoute: true },
    },
    {
      path: '/login/logout',
      name: 'logout',
      component: Logout,
      meta: { loginRoute: true },
    },
    {
      path: '/account-link',
      name: 'account-link',
      component: AccountLink,
      meta: { loginRoute: true },
    },
  ],
};
